import logo from './logo.svg';
import './App.css';
import { Layout } from 'antd';
import AppHeader from './components/Header';
import DownloadSection from './components/DownloadSection';
import Features from './components/Features';
import ProductDescription from './components/ProductDescription';
import SEO from './components/SEO';

const { Content, Footer } = Layout;

function App() {
  return (
    <>
      <SEO />
      <Layout className="App">
        <AppHeader />
        <Content>
          <DownloadSection />
          <ProductDescription />  {/* 添加这一行 */}
          <Features />
        </Content>
        <Footer style={{ textAlign: 'center' }}>
          Lifeano ©{new Date().getFullYear()} Created by Lifeano Team
        </Footer>
      </Layout>
    </>
  );
}

export default App;
